import React, { useMemo } from 'react';
import { Badge } from 'antd';
import { RocketOutlined } from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { getUnseenReleases, LATEST_VERSION, readLastSeenVersion } from '@app/components/help/releases';

interface SiderVersionProps {
  isCollapsed: boolean;
}

/**
 * Chân sidebar: phiên bản hiện tại, dẫn tới Nhật ký cập nhật.
 * Chấm xanh khi có bản phát hành user chưa xem (tự tắt sau khi vào trang releases).
 */
const SiderVersion: React.FC<SiderVersionProps> = ({ isCollapsed }) => {
  const location = useLocation();
  // Tính lại theo route: vào /help/releases sẽ đánh dấu đã xem → chấm badge tắt ngay khi điều hướng tiếp.
  const hasUnseen = useMemo(
    () => getUnseenReleases(readLastSeenVersion()).length > 0,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname],
  );

  return (
    <Link
      to="/help/releases"
      title={`Phiên bản ${LATEST_VERSION} — xem nhật ký cập nhật`}
      className={clsx(
        'tw-flex tw-items-center tw-justify-center tw-gap-1.5 tw-border-0 tw-border-t tw-border-solid tw-px-2 tw-py-3',
        'tw-border-[var(--border-color)] tw-text-xs tw-text-[var(--text-sider-secondary-color)] hover:tw-text-[var(--text-sider-primary-color)]',
      )}
    >
      <Badge dot={hasUnseen} color="green" offset={[2, 0]}>
        <RocketOutlined className="tw-text-[var(--text-sider-secondary-color)]" />
      </Badge>
      {!isCollapsed && <span>Phiên bản {LATEST_VERSION}</span>}
    </Link>
  );
};

export default SiderVersion;
